module.exports = __webpack_public_path__ + "img/brand.9464740b.svg";